import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {cmsActionTypes, LoadCMSSuccessAction} from '../actions/cms';
import {ServerForm} from '../models/servers';

export interface CmsState {
  array: ServerForm[];
}

const initialState: CmsState = {
  array: []
};

export function cmsReducer(state: CmsState = initialState, action: Action): CmsState {
  switch (action.type) {
    case cmsActionTypes.LOAD:
      return handleLoadAction();
    case cmsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case cmsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(): CmsState {
  return initialState;
}

function handleLoadSuccess(state: CmsState, action: LoadCMSSuccessAction): CmsState {
  const newState = _.clone(state);
  newState.array = action.payload || [];
  return newState;
}

function handleLoadFailAction(state: CmsState): CmsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const cmsSelectors = {
  array: (state: CmsState) => _.get(state, 'array', [])
};
